import type { FC } from "react";
import type { JSX } from "react";
import { PeriodOverPeriodItem } from "app/pages/industry-analysis/common/styledComponents";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

interface ILegendItem {
    color: string;
    title: string;
    subtitle: string | JSX.Element;
}

export const LegendItem: FC<ILegendItem> = (props) => {
    const { title, subtitle, color } = props;
    return (
        <FlexColumn gap={"4px"}>
            <PeriodOverPeriodItem
                text={title}
                color={color}
            />
            <div>{subtitle}</div>
        </FlexColumn>
    );
};
